import {
  Alert,
  Heading,
  Paragraph,
  Skeleton,
} from "@digdir/designsystemet-react";
import { useTranslation } from "react-i18next";
import { FormWrapper } from "@/components";
import { FinnLeverandoerForm } from "../forms";
import { useLeverandoerData } from "../hooks";
import { FormPage } from "./FormPage";

export function FinnLeverandoerPage() {
  const { data: leverandoerer, isLoading, error } = useLeverandoerData();
  const { t } = useTranslation();

  return (
    <FormPage>
      <Heading data-size="lg">{t("pages.finn-leverandoer.tittel")}</Heading>
      <Paragraph data-size="lg" className="text-balder-text-subtle">
        {t("pages.finn-leverandoer.beskrivelse")}
      </Paragraph>
      {isLoading && (
        <FormWrapper className="flex flex-col">
          <Skeleton variant="text" width={40} className="w-50 h-7" />
          <Skeleton className="w-full h-12" />
          <Skeleton variant="circle" className="w-30 h-12" />
        </FormWrapper>
      )}
      {error && (
        <Alert data-color="danger">
          <Heading data-size="xs">{t("skjema.feil-ved-henting")}</Heading>
          <Paragraph>
            {t("pages.finn-leverandoer.feil.leverandoerer")}
          </Paragraph>
        </Alert>
      )}
      {!isLoading && !error && (
        <FinnLeverandoerForm leverandoerer={leverandoerer} />
      )}
    </FormPage>
  );
}
